export default __webpack_public_path__ + "static/media/loading.4ed98372.svg";